<header class="header">
    <div class="header-grp">
        <div class="icon" (click)="goBackToPrevPage()">
            <i class="ti ti-chevron-left"></i>
        </div>
        <div class="title">
            <h3>આમંત્રિત સભ્ય</h3>
        </div>
    </div>
</header>
<main>
    <div class="city-search">
        <div class="filtering">
            <form>
                <input type="search" class="form-control" #filter (keyup)="applyFilter($event)" placeholder="શોધો.." />
                <i class="ti ti-search"></i>
            </form>
            <i class="ti ti-filter cursorClass" (click)="openBottomSheet()"></i>
            <a class="ti ti-refresh cursorClass" (click)="getMainMember()"></a>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="center">
                    <mat-tab label="આમંત્રિત સભ્યો">
                        <select #selectBox (change)="UpdateStatus(selectBox.value)" class="cursorClass w-100">
                            <ng-container>
                                <option value="0" selected>
                                    સભ્યો</option>
                                <option value="2">કારોબારી કમિટી</option>
                                <option value="3">યુવા કમિટી</option>
                                <option value="4">સ્ટુડન્ટ કમિટી</option>
                            </ng-container>
                        </select>
                        <div *ngIf="memberListData.length !== 0" class="main-members family-tabs">
                            <a class="member-list-item">
                                <div>
                                    <h5><b>બધા સભ્ય ને આમંત્રિત કરો.</b></h5>
                                </div>
                                <mat-checkbox #selectAllCheckbox  class="example-margin" 
                                    (change)="selectAllMembers($event)"></mat-checkbox>
                            </a>
                        </div>

                        <div class="main-members family-tabs">
                            <a *ngFor="let member of memberListData" class="member-list-item">
                                <div>
                                    <h5>{{ member.name}}</h5>
                                </div>
                                <mat-checkbox class="example-margin" [(ngModel)]="member.checked"
                                    (change)="invitationFunction($event, member.user_id)"></mat-checkbox>
                            </a>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>

    <button type="submit" class="btn-common stickeybtn" (click)="submit()">સાચવો</button>
</main>